import apiCall from './apiCall';

const getListReferenceData = async (param: any) => {
    const query = `?type=${param.type}&search=${param.search}&pageNumber=${param.pageNumber}&pageSize=${param.pageSize}`;
    const URL = `/RefData/GetAllRefDatas${query}`;
    return apiCall('get', URL);
};

const getRefData = async () => {
    const URL = '/RefData/GetDataRef';
    return apiCall('get', URL);
};

const getRefDataById = async (id: string) => {
    const URL = `/RefData/GetRefDataById/${id}`;
    return apiCall('get', URL);
};

const getListOfTypeRefData = async () => {
    const URL = '/RefData/GetListOfType';
    return apiCall('get', URL);
};

const putRefData = async (data: any) => {
    const URL = '/RefData/Update';
    return apiCall('post', URL, data);
};

const postRefData = async (data: any) => {
    const URL = '/RefData/Create';
    return apiCall('post', URL, data);
};

const deleteRefData = async (data: any) => {
    const URL = '/RefData/Delete';
    return apiCall('post', URL, data);
};

export {
    getListReferenceData,
    getRefData,
    getRefDataById,
    getListOfTypeRefData,
    putRefData,
    postRefData,
    deleteRefData
}
